var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8073 9.42642L30.6513 57.986C30.0906 58.9885 28.6502 58.9944 28.0811 57.9967L0.386671 9.4311C-0.233322 8.34386 0.696385 7.02692 1.92844 7.24713L29.1134 12.1063C29.2869 12.1373 29.4644 12.137 29.6378 12.1054L56.2543 7.2541C57.4823 7.0303 58.4163 8.33704 57.8073 9.42642Z",
    fill: "url(#paint0_linear_708_445)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0631 0.873625L21.9669 4.8114C21.6366 4.87611 21.3921 5.15603 21.3721 5.49196L20.1359 26.3703C20.1069 26.8621 20.5585 27.2438 21.0384 27.1331L26.6335 25.8418C27.157 25.7211 27.63 26.1821 27.5224 26.7086L25.8602 34.8485C25.7483 35.3964 26.2626 35.8648 26.7976 35.7023L30.2534 34.6524C30.7892 34.4897 31.3039 34.9595 31.1906 35.5078L28.5489 48.2938C28.3836 49.0936 29.4474 49.5297 29.8911 48.844L30.1874 48.3861L46.5629 15.7059C46.8372 15.1587 46.3643 14.5348 45.7633 14.6508L40.0041 15.7623C39.4629 15.8666 39.0024 15.3626 39.1552 14.8331L42.9141 1.80232C43.067 1.27193 42.6049 0.767477 42.0631 0.873625Z",
    fill: "url(#paint1_linear_708_445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_708_445",
    x1: -0.289508,
    y1: 5.51169,
    x2: 33.5082,
    y2: 51.4116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD34FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_708_445",
    x1: 27.5531,
    y1: 1.94272,
    x2: 33.667,
    y2: 43.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    stopColor: "#FFDD35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViteLogo);
export default __webpack_public_path__ + "static/media/vite-logo.4fad9a7a5601c8ba52029fadaa75e6c6.svg";
export { ForwardRef as ReactComponent };